





































import { Mixins, Component, Prop, Watch } from "vue-property-decorator";
import i18n from "@/i18n";

// Mixins
import HasValidation from "@/mixins/HasValidation";

@Component
export default class MultiValueSelect extends Mixins(HasValidation) {
  // Props
  @Prop({ required: true })
  public value!: any;

  @Prop({ default: i18n.t("_.select_new") })
  public placeholder!: string;

  @Prop({ required: true })
  public options!: { value: any; label: string }[];

  @Prop({ required: true })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public multiple!: boolean;

  public get selectedOptions() {
    return this.value;
  }

  public set selectedOptions(value) {
    this.$emit("input", value);
  }

  public selectedTags: string[] = [];
  public searchedValue = "";

  public remove(label) {
    this.selectedOptions = this.$_.filter(
      this.selectedOptions,
      selectedOption =>
        this.$_.get(this.$_.find(this.options, ["label", label]), "value") !==
        selectedOption
    );
  }

  private get hasCustomSlot() {
    return !!this.$slots.custom;
  }

  public get selectOptions() {
    if (this.searchedValue === "") return this.options;

    return this.$_.filter(this.options, option =>
      option.label.toLowerCase().includes(this.searchedValue.toLowerCase())
    );
  }

  public typing(value) {
    this.searchedValue = value;
  }

  @Watch("selectedOptions", { immediate: true })
  public onSelectedOptionsChange() {
    this.selectedTags = this.multiple
      ? this.$_.map(this.selectedOptions, selectedOption => {
          return this.$_.get(
            this.$_.find(this.options, ["value", selectedOption]),
            "label",
            ""
          );
        })
      : [
          this.$_.get(
            this.$_.find(this.options, ["value", this.selectedOptions]),
            "label",
            ""
          )
        ];

    if (!this.multiple && this.selectedTags[0] === "") this.selectedTags = [];
  }
}
